import Logger from './Logger';

export const getServerURL = (): string => {
  if (window.env == null || !window.env.SERVER_URL) {
    Logger.error(Error(`Could not get server url`));
    return '';
  } else {
    return window.env.SERVER_URL;
  }
};
